import { BaseMapper } from "../shared/base.mapper";
import { Company } from "../../types/admon/company.type";
import { Injectable } from "@angular/core";

@Injectable()
export class CompanyMapper extends BaseMapper<Company> {
    constructor() {
        super();
    }
}
